var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_content",attrs:{"id":"header_content"}},[_c('Banner',{scopedSlots:_vm._u([{key:"pinb",fn:function(){return [_vm._t("pin")]},proxy:true}],null,true)}),_vm._v(" "),_c('HeaderTop')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8f3d4b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderProject.vue
// module id = null
// module chunks = 